import React from "react";
import { Button } from "antd";
import Icons from "components/icons";
import { DrawerStandart, Localize, localizeByKeyStatic } from "components/service";
import CommunicationConst from "../communication-const";
import CommunicationForms from "../forms";
import type {
  TCommunicationAuditEntry,
  TCommunicationReferenceOption,
  TCommunicationTab,
  TCommunicationTask,
} from "../helpers/communication-types-helper";

interface ICommunicationActionFieldProps {
  task: TCommunicationTask;
  canEditRaw: boolean;
  canApprove: boolean;
  currentTab: TCommunicationTab;
  equipmentOptions: TCommunicationReferenceOption[];
  flooringOptions: TCommunicationReferenceOption[];
  organizerOptions: TCommunicationReferenceOption[];
  exhibitionOptions: TCommunicationReferenceOption[];
  auditEntry?: TCommunicationAuditEntry;
  onSave: (taskId: string, values: any) => void;
  onApprove: (taskId: string, values: any) => void;
}

const CommunicationActionField: React.FC<ICommunicationActionFieldProps> = ({
  task,
  canEditRaw,
  canApprove,
  currentTab,
  equipmentOptions,
  flooringOptions,
  organizerOptions,
  exhibitionOptions,
  auditEntry,
  onSave,
  onApprove,
}) => {
  const buttonLabel =
    currentTab === "audit"
      ? localizeByKeyStatic("COMMUNICATION.Button_View")
      : task.status === CommunicationConst.statuses.UNIDENTIFIED
        ? localizeByKeyStatic("COMMUNICATION.Button_StartMatch")
        : localizeByKeyStatic("COMMUNICATION.Button_StartReview");

  return (
    <DrawerStandart
      width={980}
      extraClass="model-form communication-drawer"
      modalButton={
        <Button
          className="communication-action-button"
          icon={currentTab === "audit" ? <Icons.Information /> : <Icons.Edit />}
        >
          <span className="ellipsis">{buttonLabel}</span>
        </Button>
      }
    >
      <strong className="modal-title">
        <span className="text">
          <Localize>
            {currentTab === "audit"
              ? "COMMUNICATION.Title_AuditEntry"
              : "COMMUNICATION.Title_EmailChange"}
          </Localize>
        </span>
      </strong>

      <CommunicationForms.Task
        task={task}
        canEditRaw={canEditRaw}
        canApprove={canApprove}
        isAuditView={currentTab === "audit" || task.status === CommunicationConst.statuses.APPROVED}
        equipmentOptions={equipmentOptions}
        flooringOptions={flooringOptions}
        organizerOptions={organizerOptions}
        exhibitionOptions={exhibitionOptions}
        auditEntry={auditEntry}
        onSave={onSave}
        onApprove={onApprove}
      />
    </DrawerStandart>
  );
};

export default CommunicationActionField;
